
module.exports = {
	USER_INFO: 'user_info',			// 用户信息
	TOKEN: 'token',					// Token
	BACK_URL: 'back_url',			// Back URL
	CONFIG: 'config',				// 配置
	INVITE_CODE: 'invite_code',		// Invite Code
	THEME_CONFIG: 'theme_config',	
}